/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `AS` - AI Sample
* `SS` - Sample Supporting Photo
* `BP` - Bale Photo
* `EU` - External Upload
* `LFR` - LiDAR Feed Recording
* `LP` - Loading Photo
* `MP` - Marketing Photo
* `MS` - Material Specification
* `O` - Other
* `SB` - Sample
* `SP` - Site Photo
* `UP` - Unloading Photo
 */
export type EvidenceTypeEnum = typeof EvidenceTypeEnum[keyof typeof EvidenceTypeEnum];


export const EvidenceTypeEnum = {
  AS: 'AS',
  SS: 'SS',
  BP: 'BP',
  EU: 'EU',
  LFR: 'LFR',
  LP: 'LP',
  MP: 'MP',
  MS: 'MS',
  O: 'O',
  SB: 'SB',
  SP: 'SP',
  UP: 'UP',
} as const;
